import React, { Fragment, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import clsx from "clsx";
import { Switch, Route, Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Workspace, Header, SidebarWrapper } from "../components";
import RoutesDashboard from "../RoutesDashboard";
import RoutesDashboardDea from "../RoutesDashboardDea";
import RoutesDashboardNtt from "../RoutesDashboardNtt";
import RoutesDashboardNoReport from "../RoutesDashboardNoReport";
import RoutesDashboardCommon from "../RoutesDashboardCommon";
import RoutesDashboardSaitama from "../RoutesDashboardSaitama";
import RoutesDashboardJr from "../RoutesDashboardJr";
import DashboardStyles from "./DashboardStyles";
import { HINAN_KUNREN_COMMON_ACCESS_KEY } from "../config/HinanKunrenConfig";
import { SAITAMA_CITY_PROVIDER } from "../config/SaitamaCityConfig";
import { isJrAccessKey } from "../config/JrConfig";

export const shouldRedirectJrReport = (accessKey, pathname, jrPredicate = isJrAccessKey) =>
  jrPredicate(accessKey) &&
  (pathname === "/report" || pathname.startsWith("/report-viewer"));

export const selectDashboardRoutes = (accessKey, jrPredicate = isJrAccessKey) => {
  const isTepcoMenu = accessKey === "undefined" || accessKey === "td94cq1n92ivx6q7hpu3uxvn";
  const isNoReportMenu = accessKey === "k3v9q1m7x8d2p5n0z6h4w1r9";
  const isSaitamaMenu = accessKey === SAITAMA_CITY_PROVIDER.accessKey;

  if (jrPredicate(accessKey)) {
    return RoutesDashboardJr;
  }

  let dashboardRoutes = isSaitamaMenu
                            ? RoutesDashboardSaitama
                            : isNoReportMenu
                            ? RoutesDashboardNoReport
                            : accessKey === "dea"
                              ? RoutesDashboardDea
                              : isTepcoMenu
                              ? RoutesDashboard
                              : RoutesDashboardNtt;

  if (accessKey === HINAN_KUNREN_COMMON_ACCESS_KEY) {
    dashboardRoutes = RoutesDashboardCommon;
  }

  return dashboardRoutes;
};

function resizeDispatch() {
  if (typeof Event === "function") {
    window.dispatchEvent(new Event("resize"));
  } else {
    const evt = window.document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
  }
}

const Dashboard = (props) => {
  const {
    classes,
    filterDrawerState,
    currentPage,
    handleLogout,
    isAuthenticated,
    location,
  } = props;
  const [opened, setOpened] = useState(true);

  const handleDrawerToggle = useCallback(() => {
    setOpened((prevOpened) => !prevOpened);
    resizeDispatch();
  }, []);

  const accessKey =
    props.accessKey != null ? props.accessKey : localStorage.getItem("access_key");

  if (location.pathname === "/plot" && accessKey !== "dea") {
    return <Redirect to="/home" />;
  }
  if (shouldRedirectJrReport(accessKey, location.pathname)) {
    return <Redirect to="/home" />;
  }
  const dashboardRoutes = selectDashboardRoutes(accessKey);

  const getRoutes = (
    <Switch>
      {dashboardRoutes.items.map((item, index) => (
        <Route
          exact
          path={item.path}
          component={item.component}
          name={item.name}
          key={index}
        />
      ))}
    </Switch>
  );

  return (
    <Fragment>
      <Header
        logoAltText=""
        logo={`/static/images/logo-main.png`}
        toggleDrawer={handleDrawerToggle}
        isAuthenticated={isAuthenticated}
        isDeaAdmin={props.isDeaAdmin}
        handleLogout={handleLogout}
        currentLocation={location.pathname}
      />
      <div className={classNames(classes.panel, "theme-dark")}>
        {!currentPage.includes("viewer") && (
          <SidebarWrapper
            routes={dashboardRoutes.items}
            opened={opened}
            toggleDrawer={handleDrawerToggle}
            handleLogout={handleLogout}
          />
        )}
        <div
          className={clsx(classes.content, {
            [classes.contentShift]: filterDrawerState,
          })}
        >
          <Workspace opened={opened} currentLocation={location.pathname}>
            {getRoutes}
          </Workspace>
        </div>
      </div>
    </Fragment>
  );
};

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  accessKey: PropTypes.string,
};

const mapStateToProps = (state) => ({
  currentPage: state.app.currentPage,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(DashboardStyles, { withTheme: true })(Dashboard));
